import React from 'react';
import { ImageRendererFactory } from 'app/interfaces/ImageRenderer';

const MainImageRendererFactoryContext = React.createContext<ImageRendererFactory>(undefined);

export default MainImageRendererFactoryContext;
